export default "__VITE_ASSET__BwHXEhCB__"